// extracted by mini-css-extract-plugin
export default {"input":"styles_input__DYdPx","inputDigitalError":"styles_inputDigitalError__uRh5J"};